import React, { useState } from "react";
import { About, Skills, Footer, Header, Work, Testimonials } from "./container";
import { Navbar } from "./components";
import Chat from "./container/Chat";

import "./App.scss";
const App = () => {
  // const [mode, setMode] = useState("light");

  return (
    <div >
      <Chat />
      <Navbar />
      <Header/>
      {/* {console.log(mode)} */}
      <About  />
      <Work  />
      <Skills  />
      {/* <Testimonials /> */}
      <Footer  />
    </div>
  );
};

export default App;
